import ActiveFilters from "@/components/ActiveFilters.tsx";
import AlphaFilter from "@/components/AlphaFilter.tsx";
import PolicyListingSelectFilters from "@/components/MultiSelect.tsx";
import SearchFilter from "@/components/SearchFilter.tsx";

import { hasActiveFilters, useListingFilters} from '@/utils/listing-utils.ts';
import type {Label} from "@/types/types.ts";

interface FormProps {
    categories: Label[],
}

/**
 * Component for the form in the Listing
 */

export default function Form({categories}: FormProps) {
    const { search } = useListingFilters();
    const showActiveFilters = hasActiveFilters(search);

    return(
        <div className="policy-library-listing-form">
            <SearchFilter />
            <div className="select-filters">
                <PolicyListingSelectFilters categories={categories}  />
                <AlphaFilter />
            </div>
            {showActiveFilters && <ActiveFilters labelData={categories} />}
        </div>
    )
}